import React from "react";
import { createBrowserRouter } from "react-router-dom";

// common
import SignInHomePage from "../pages/common/sign-in/home";
import ProfileConfigPage from "../pages/common/sign-in/profile-config";
import LogInPage from "../pages/common/log-in";

// page
import HomePage from "../pages/home";
import ChatHomePage from "../pages/chat/home";
import ChatPage from "../pages/chat/chat";
import CalendarHomePage from "../pages/calendar/home";
import ProfileHomePage from "../pages/profile/home";
import SearchHomePage from "../pages/search/home";
import SearchProfilePage from "../pages/search/profile";
import GroupsHomePage from "../pages/groups/home";
import GroupPage from "../pages/groups/group";

// abe-quitar;
import TestPage from "../pages/test";

// layouts
import PublicLayout from "../layouts/public";
import MainLayout from "../layouts/main";
import MenuLayout from "../layouts/menu";

// elems
import ChatHeader from "../components/chat-header";
import ChatInput from "../components/chat-input";
import MenuMobile from "../components/menu-mobile";
import SimpleHeader from "../components/simple-header";

// loaders
import {
  redirectIfLogged,
  redirectIfNoLogged,
  redirectHome,
} from "./loaders/routes";
import init from "./loaders/init";

const router = createBrowserRouter(
  [
    {
      path: "/",
      element: <></>,
      loader: async () => {
        await init();
        return await redirectHome();
      },
    },
    {
      path: "/sign-in",
      element: (
        <PublicLayout>
          <SignInHomePage />
        </PublicLayout>
      ),
      loader: async () => {
        await init();
        return await redirectIfLogged();
      },
    },
    {
      path: "/sign-in/profile-config",
      element: (
        <MainLayout>
          <ProfileConfigPage />
        </MainLayout>
      ),
      loader: async () => {
        await init();
        return await redirectIfNoLogged();
      },
    },
    {
      path: "/log-in",
      element: (
        <PublicLayout>
          <LogInPage />
        </PublicLayout>
      ),
      loader: async () => {
        await init();
        return await redirectIfLogged();
      },
    },

    {
      path: "/home",
      element: (
        <MenuLayout
          footer={() => <MenuMobile />}
          header={() => <SimpleHeader text="Home" />}
        >
          <HomePage />
        </MenuLayout>
      ),
      loader: async () => {
        await init();
        return await redirectIfNoLogged();
      },
    },
    {
      path: "/chat",
      element: (
        <MenuLayout
          fullHeight={true}
          footer={() => <MenuMobile />}
          header={() => <SimpleHeader text="Chat" />}
        >
          <ChatHomePage />
        </MenuLayout>
      ),
      loader: async () => {
        await init();
        return await redirectIfNoLogged();
      },
    },
    {
      path: "/chat/:chatId",
      element: (
        <MenuLayout
          fullHeight={true}
          noScroll={true}
          style={{ padding: "0px" }}
          footer={() => <ChatInput />}
          header={() => <ChatHeader />}
        >
          <ChatPage />
        </MenuLayout>
      ),
      loader: async ({ request }) => {
        await init();
        return await redirectIfNoLogged();
      },
    },
    {
      path: "/calendar",
      element: (
        <MenuLayout
          fullHeight={true}
          footer={() => <MenuMobile />}
          header={() => <SimpleHeader text="Calendario" />}
        >
          <CalendarHomePage />
        </MenuLayout>
      ),
      loader: async () => {
        await init();
        return await redirectIfNoLogged();
      },
    },
    {
      path: "/profile",
      element: (
        <MenuLayout
          style={{ padding: "0px" }}
          footer={() => <MenuMobile />}
          header={() => <SimpleHeader text="Perfil" />}
        >
          <ProfileHomePage />
        </MenuLayout>
      ),
      loader: async () => {
        await init();
        return await redirectIfNoLogged();
      },
    },

    {
      path: "/search",
      element: (
        <MenuLayout
          footer={() => <MenuMobile />}
          header={() => <SimpleHeader text="Usuarios" />}
        >
          <SearchHomePage />
        </MenuLayout>
      ),
      loader: async () => {
        await init();
        return await redirectIfNoLogged();
      },
    },
    {
      path: "/search/profiles/:uid",
      element: (
        <MenuLayout style={{ padding: "0px" }} footer={() => <MenuMobile />}>
          <SearchProfilePage />
        </MenuLayout>
      ),
      loader: async () => {
        await init();
        return await redirectIfNoLogged();
      },
    },
    {
      path: "/grupos",
      element: (
        <MenuLayout
          style={{ padding: "0px" }}
          footer={() => <MenuMobile />}
          header={() => <SimpleHeader text="Grupos de investigación" />}
        >
          <GroupsHomePage />
        </MenuLayout>
      ),
      loader: async () => {
        await init();
        return await redirectIfNoLogged();
      },
    },
    {
      path: "/grupo/:groupId",
      element: (
        <MenuLayout
          style={{ padding: "0px" }}
          header={() => <SimpleHeader backArrow={true} />}
        >
          <GroupPage />
        </MenuLayout>
      ),
      loader: async () => {
        await init();
        return await redirectIfNoLogged();
      },
    },
    {
      path: "/test",
      element: (
        <MenuLayout
          style={{ padding: "0px" }}
          header={() => <SimpleHeader backArrow={true} />}
        >
          <TestPage />
        </MenuLayout>
      ),
      loader: async () => {
        await init();
        return await redirectIfNoLogged();
      },
    },
  ],
  { basename: "/area-socios" }
);

export default router;
